import { Tooltip } from 'antd';
import { useMemo } from 'react';

import { TagItem, TooltipItem } from './styles';

type Props = {
  label?: string;
  name: string;
  value: string[];
  valueDictionary?: Record<string, string>;
  onClose: (name: string) => void;
};

const FilterTag = ({
  name,
  label,
  value,
  valueDictionary = {},
  onClose
}: Props) => {
  const [firstValue, ...rest] = value;
  const displayName = label ?? name;
  const mainText = firstValue
    ? `${displayName} ${valueDictionary[firstValue] ?? value}`
    : '';
  const isMultiple = rest.length > 0;
  const countText = isMultiple ? `+${rest.length}` : '';

  const tooltipContent = useMemo(
    () => (
      <>
        {rest.map(value => (
          <TooltipItem key={value}>
            {`${displayName} ${valueDictionary[value] ?? value}`} <br />
          </TooltipItem>
        ))}
      </>
    ),
    [displayName, valueDictionary, rest]
  );
  return (
    <Tooltip placement='bottom' title={isMultiple ? tooltipContent : undefined}>
      <TagItem bordered={false} closable={true} onClose={() => onClose(name)}>
        {mainText} {countText}
      </TagItem>
    </Tooltip>
  );
};

export default FilterTag;
